import { render, staticRenderFns } from "./searchButtons.vue?vue&type=template&id=2c171bd2&"
import script from "./searchButtons.vue?vue&type=script&lang=js&"
export * from "./searchButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports